import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../shared/guards/auth-guard';
import { ContactComponent } from './contact.component';

const contactRoutes: Routes = [
    {
        path: 'contact',
        component: ContactComponent,
        canActivate: [AuthGuard],
        data: { title: 'Contacts' }
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(contactRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class ContactRoutingModule { }
